const _excluded = ["style", "className", "children", "hide", "onClick", "onEscape", "onAnimationStart", "onAnimationComplete", "initial", "animate", "exit"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import Animation from '@adsk/alloy-react-animation';
import { useKeyEvent } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const ESCAPE = 'Escape';
const Overlay = _ref => {
  let {
      style,
      className,
      children,
      hide,
      onClick,
      onEscape,
      onAnimationStart,
      onAnimationComplete,
      initial = {
        opacity: 0
      },
      animate = {
        opacity: 1
      },
      exit = {
        opacity: 0
      }
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  useKeyEvent(ESCAPE, {
    onKeyDown: onEscape
  });
  return /*#__PURE__*/React.createElement(Animation, _extends({
    key: "modal",
    initial: initial,
    animate: animate,
    exit: exit,
    className: className,
    onClick: onClick,
    onAnimationStart: onAnimationStart,
    onAnimationComplete: onAnimationComplete
  }, props, {
    style: [_objectSpread({
      position: 'fixed',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: theme.colors.darkBlue900Alpha45,
      bottom: 0,
      left: 0,
      right: 0,
      top: 0,
      zIndex: theme.zIndex.overlay
    }, hide && {
      background: 'transparent',
      pointerEvents: 'none'
    }), style]
  }), children);
};
Overlay.propTypes = {
  /** The content of the overlay */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** hide overlay  */
  hide: PropTypes.bool,
  /** handle onclick event for Overlay */
  onClick: PropTypes.func,
  /** called when motion.div Animation Complete and overlay closed */
  onAnimationComplete: PropTypes.func,
  /** called when motion.div Animation Starts and overlay open */
  onAnimationStart: PropTypes.func
};
export default Overlay;
//# sourceMappingURL=Overlay.js.map